'use strict';

var size = require('../../size.js');

var height = {
  'height-0': {
    value: size.size[0]
  },
  'height-025': {
    value: size.size['025']
  },
  'height-050': {
    value: size.size['050']
  },
  'height-100': {
    value: size.size[100]
  },
  'height-150': {
    value: size.size[150]
  },
  'height-200': {
    value: size.size[200]
  },
  'height-300': {
    value: size.size[300]
  },
  'height-400': {
    value: size.size[400]
  },
  'height-500': {
    value: size.size[500]
  },
  'height-600': {
    value: size.size[600]
  },
  'height-700': {
    value: size.size[700]
  },
  'height-800': {
    value: size.size[800]
  },
  'height-900': {
    value: size.size[900]
  },
  'height-1000': {
    value: size.size[1000]
  },
  'height-1200': {
    value: size.size[1200]
  },
  'height-1600': {
    value: size.size[1600]
  },
  'height-2000': {
    value: size.size[2000]
  },
  'height-2400': {
    value: size.size[2400]
  },
  'height-2800': {
    value: size.size[2800]
  },
  'height-3200': {
    value: size.size[3200]
  }
};

exports.height = height;
